import { StoryFramesModel } from 'interface/models';
import { FrameHeader } from '../shared/FrameHeader';
import { TimelinePlan_Frame } from './TimelinePlan_Frame';
import { Divider } from 'antd';

export const TimelinePlan_OneFrameRow = (props: {
  setNewTimeStart: any;
  onChange: (frame: StoryFramesModel) => void;
  qFrames: any;
  storyId: number;
  current: StoryFramesModel;
  next: StoryFramesModel;
  prev: StoryFramesModel;
  displayType: string;
}) => {
  const { next, prev, current, qFrames } = props;
  return (
    <>
      <FrameHeader
        key={current.id + `FrameHeader`}
        current={current}
        prev={prev}
        next={next}
        displayType={props.displayType}
        setNewTimeStart={props.setNewTimeStart}
        qFrames={qFrames}
        storyId={props.storyId}
        onChange={(frame: StoryFramesModel) => {
          props.onChange(frame);
        }}
        onReload={() => {
          qFrames.refetch();
        }}
      />
      <TimelinePlan_Frame
        key={current.id + `StoryFrame`}
        frame={current}
        displayType={props.displayType}
        storyId={props.storyId}
        onChange={(frame: StoryFramesModel) => {
          props.onChange(frame);
        }}
        onReload={() => {
          qFrames.refetch();
        }}
      />
      <br />
    </>
  );
};
